import { useEffect } from 'react';
import env from 'environments';

/**
 * GHL Session Bridge Callback
 *
 * This component handles the FusionAuth OAuth callback and redirects
 * to the GHL SSO URL. It establishes a FusionAuth browser session
 * which allows seamless SSO into GoHighLevel.
 *
 * Flow:
 * 1. User clicks "Launch Marketing Hub"
 * 2. User is redirected to FusionAuth OAuth authorize
 * 3. FusionAuth authenticates user (creates browser session)
 * 4. FusionAuth redirects here with auth code
 * 5. This component redirects to GHL SSO
 * 6. GHL SSO uses FusionAuth session for auto-login
 */
const GhlCallback = () => {
  useEffect(() => {
    // Get the GHL SSO URL from sessionStorage (set by MarketingHub)
    const ghlUrl = sessionStorage.getItem('ghl_redirect_url');

    // Clean up sessionStorage
    sessionStorage.removeItem('ghl_redirect_url');

    // Build the GHL SSO URL - use stored URL or default
    const ghlSsoUrl = ghlUrl || `https://${env.GHL_WHITELABEL_DOMAIN}/login/sso`;

    // Redirect to GHL SSO - FusionAuth session is now established
    window.location.href = ghlSsoUrl;
  }, []);

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        flexDirection: 'column',
      }}
    >
      <div
        style={{
          border: '4px solid #f3f3f3',
          borderTop: '4px solid #3B82F6',
          borderRadius: '50%',
          width: '40px',
          height: '40px',
          animation: 'spin 1s linear infinite',
        }}
      />
      <p style={{ marginTop: '16px', color: '#666' }}>Redirecting to Marketing Hub...</p>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

export default GhlCallback;
